<template>
  <button @click="$emit(action)" type="button" class="w3-button" style="margin:0px; padding:0px">
    <font-awesome-icon :icon="[type, icon]" />
  </button> 
</template>

<script>
  import ToggleButton from "./ToggleButton.ts";

  export default ToggleButton;
</script>
